import React, { useState } from "react";
import { css } from "emotion";
import { collapse } from "./style";
import { Button } from "@maxmilhas/hangar-components-atomic/public";
import Loading from "../../../../../offers/shared/Loading/Loading";


const Collapse = props => {

    const { title, text, buttonText, dataAction, onClick, children, disabledButton } = props;
    const [showDetails, setShowDetails] = useState(false)

    return (
        <div className={css`${collapse}`}>
            <h1 className="collapse__title">{title}</h1>
            <div className="collapse__row">
                <div className="collapse__content">
                    <div className="collapse__text">
                        <p>{text}</p>
                    </div>

                    <div className="collapse__button">
                        <Button
                            outline={true}
                            color="#c8ccd4"
                            disabled={!!disabledButton}
                            icon={null}
                            onClick={onClick}
                            size={null}
                            type="button"
                        >
                            {buttonText}
                        </Button>
                    </div>
                </div>

                {showDetails && (
                    <>
                        {children}
                        <div
                            className={`collapse__details-button ${showDetails ? "opened" : ""}`}
                        >
                            <button
                                className="btn"
                                onClick={() => setShowDetails(!showDetails)}
                                data-action={dataAction}
                            >
                                <span>Menos detalhes</span>
                                <i className="icon-arrow-down" />
                            </button>
                        </div>
                    </>
                )}

                {!showDetails && (
                    <div
                        className={`collapse__details-button ${showDetails ? "opened" : ""}`}
                    >
                        <button
                            className="btn"
                            onClick={() => setShowDetails(!showDetails)}
                            data-action={dataAction}
                        >
                            <span>Ver detalhes</span>
                            <i className="icon-arrow-down" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}


export default Collapse
